/**
 * Global constants for Pickle Pong
 */

export const ADMIN_WALLETS = [
    'I5VOLJMONSXTEFKRSY6XEL6ADSPL7MZCIZFGKC3WGDHEXOIO6BRMQHDWTA',
    'O2ZPSV6NJC32ZXQ7PZ5ID6PXRKAWQE2XWFZK5NK3UFULPZT6OKIOROEAPU'
];
